import { resolveIdentifier, types } from 'mobx-state-tree';

import PaymentMethod from './PaymentMethod';
import PaymentMethodGroup from './PaymentMethodGroup';
import { OrderPaymentProviderType } from '../../../../types/order/OrderPaymentProvider';

const SelectedPayment = types
  .model('SelectedPayment', {
    group: types.maybeNull(types.safeReference(PaymentMethodGroup)),
    method: types.maybeNull(types.safeReference(PaymentMethod)),
    provider: types.maybeNull(OrderPaymentProviderType),
  })
  .actions((self) => {
    return {
      updatePaymentMethodGroup({ id, groups }) {
        const group = resolveIdentifier(PaymentMethodGroup, groups, id);
        self.group = group;
        self.method = group.methods[0];
      },
      updatePaymentMethod({ id, methods }) {
        self.method = resolveIdentifier(PaymentMethod, methods, id);
      },
      updatePaymentProvider({ id }) {
        self.provider = id;
      },
    };
  });

export default SelectedPayment;
